import { forwardRef } from 'react';
import type { ComponentPropsWithRef } from 'react';
import clsx from 'clsx';

const styleBase = {
    default: 'text-xs my-1 font-GMedium'
} as const;

const styleTypeMessage = {
    error: 'text-icoRed',
    valid: 'text-icoGreen'
} as const;

type FormFieldMessageProps = ComponentPropsWithRef<'p'> & {
    className?: string;
    type?: keyof typeof styleTypeMessage;
    baseStyle?: keyof typeof styleBase;
};

const FormFieldMessage = forwardRef<HTMLParagraphElement, FormFieldMessageProps>(
    ({ children, className = '', type = 'error', baseStyle = 'default', ...restProps }, ref) => {
        return (
            <p
                ref={ref}
                className={clsx(
                    className,
                    'w-full',
                    styleTypeMessage[type] ?? styleTypeMessage['error'],
                    styleBase[baseStyle] ?? styleBase['default']
                )}
                role="alert"
                {...restProps}>
                {children}
            </p>
        );
    }
);

FormFieldMessage.displayName = 'FormFieldMessage';

export default FormFieldMessage;
